import { ikigaiJobsVar } from '../../cache/learner/ikigaiJobsReactiveVar';
import { decryptor, encryptor } from '../../utils/decryptor';

interface IUseIkigaiJobsHook {
  operations: {
    setIkigaiJobs: (jobs: string[]) => void;
    setFromLocalIkigaiJobs: () => boolean;
  };
}

const useIkigaiJobsHook = (): IUseIkigaiJobsHook => {
  const setIkigaiJobs = (jobs: string[]): void => {
    ikigaiJobsVar({
      error: undefined,
      data: jobs,
    });

    const encryptedData = encryptor(JSON.stringify(jobs));

    if (!encryptedData) {
      return;
    }

    sessionStorage.setItem('ikigaiJobs', encryptedData);
  };

  const setFromLocalIkigaiJobs = (): boolean => {
    const storedIkigaiJobs = sessionStorage.getItem('ikigaiJobs');
    const decryptedData = decryptor(storedIkigaiJobs ?? '');

    if (!decryptedData) {
      return false;
    }

    ikigaiJobsVar({
      error: undefined,
      data: JSON.parse(decryptedData),
    });

    return true;
  };

  return {
    operations: {
      setIkigaiJobs,
      setFromLocalIkigaiJobs,
    },
  };
};

export default useIkigaiJobsHook;
